import esResources from './es-mx';
import enResources from './en-us';

export default Object.assign({}, esResources, enResources);
